import { buildSlice, PatientState } from './slice';

const patient = buildSlice((state: { patient: PatientState }) => state.patient);
export default patient;
export const selectors = patient.selectors;
